import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="page-testimonials" className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-16">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">Testimonials</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1] max-w-4xl">In the words of the people who let us into their homes.</h1>
      </section>
      <section className="container-editorial pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 border-t border-[#D5D0C8] pt-14">
          {items.map((t) => (
            <blockquote key={t.id} className="border-b border-[#D5D0C8] pb-12">
              <div className="text-[#A85C42] font-serif text-4xl leading-none">"</div>
              <div className="font-serif text-2xl md:text-3xl leading-snug italic mt-2">{t.quote}</div>
              <div className="mt-6 text-sm">
                <div className="text-[#2B2927]">{t.author}</div>
                <div className="text-[#7A736C]">{t.role}{t.location ? ` · ${t.location}` : ""}</div>
              </div>
            </blockquote>
          ))}
        </div>
      </section>
    </div>
  );
}
